
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import { get_sync_external_ticket } from "@/store/apis/auth";
import { ROOT_ERROR } from "@/store/modules/root/constants";

export default Vue.extend({
  name: "HelloUser",
  data() {
    return {
      hello_illustration: require("@/assets/illustrations/waving-hand.svg"),
      redirecting: false
    };
  },
  computed: {
    ...mapGetters("auth", {
      user: GET_USER_DETAILS
    })
  },
  mounted() {
    // Debug: Check user object and ID
    console.log("User object:", this.user);
    console.log("User ID:", this.user?.id);
    console.log("User exists:", !!this.user);
    console.log("User ID exists:", !!this.user?.id);
    // Call handleRemoteWorkRedirect on mount
    // this.handleRemoteWorkRedirect();
  },
  methods: {
    ...mapMutations({
      set_root_error: ROOT_ERROR
    }),
    async handleRemoteWorkRedirect() {
      try {
        // Validate user ID exists
        if (!this.user || !this.user.id) {
          console.error("User not found. Please log in again.");
          this.set_root_error("User not found. Please log in again.");
          return;
        }
        this.redirecting = true;
        const response = await get_sync_external_ticket(this.user.id);
        const redirectUrl = `${process.env.VUE_APP_API_BASE_URL}?ticket=${response.data.data.redirectToken}`;

        if (redirectUrl) {
          // Open in same tab
          window.location.href = redirectUrl;
        }
      } catch (error: any) {
        this.set_root_error(
          error?.response?.data?.message || "Failed to generate redirect URL"
        );
      } finally {
        this.redirecting = false;
      }
    }
  }
});
